import axios from "axios";



export interface Store {
    id?: string;
    name: string;
}
export async function fetchStores(): Promise<Store[]> {
    const response = await axios.get("/Store/get");
    return response.data;
}
export async function addStore(newStore: Store): Promise<Store> {
    const response = await axios.post("/Store/new", newStore);
    return response.data;
}
